import React from 'react';

import * as S from './styles';

import { Skeleton } from '../../Skeleton';

import { formatGtm } from '../../../../utils/formatGtm';

import { MiniBannerProps } from './types';

export const MiniBanner = ({
	miniBannerTitle,
	miniBannerSubtitle,
	miniBannerAutoDesktop = 'https://via.placeholder.com/123x140',
	miniBannerAutoMobile = 'https://via.placeholder.com/97x110',
	miniBannerLinkUrl = '',
	miniBannerExternalLink = true,
	miniBannerBgColor = '#8043ff',
	isLoading = false,
}: MiniBannerProps) => {
	function handleClick(url: string, target: boolean) {
		window.open(url, target ? '_blank' : '_self');
	}
	return (
		<>
			{isLoading ? (
				<Skeleton width={100} height={11} borderRadius={1.6} />
			) : (
				<S.Link
					href={miniBannerLinkUrl}
					target={!miniBannerExternalLink ? '_blank' : '_self'}
					aria-label={miniBannerTitle}
					role="mini-banner-link"
					rel="noreferrer"
					data-gtm-type="click"
					data-gtm-clicktype="card"
					data-gtm-name={formatGtm(miniBannerTitle!)}
					onClick={() =>
						handleClick(miniBannerLinkUrl!, miniBannerExternalLink!)
					}
				>
					<S.Container miniBannerBgColor={miniBannerBgColor}>
						<S.MiniBannerContent>
							<S.Title>{miniBannerTitle}</S.Title>
							<S.Subtitle>{miniBannerSubtitle}</S.Subtitle>
						</S.MiniBannerContent>
						<S.Image
							miniBannerAutoMobile={miniBannerAutoMobile}
							miniBannerAutoDesktop={miniBannerAutoDesktop}
						/>
					</S.Container>
				</S.Link>
			)}
		</>
	);
};
